import { render, staticRenderFns } from "./PInfoBar.vue?vue&type=template&id=6120a442&scoped=true"
import script from "./PInfoBar.vue?vue&type=script&lang=ts"
export * from "./PInfoBar.vue?vue&type=script&lang=ts"
import style0 from "./PInfoBar.vue?vue&type=style&index=0&id=6120a442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120a442",
  null
  
)

export default component.exports